<div class="card-header">

  <div class="d-flex justify-content-between">
    <button class="btn btn-link" (click)="goBack()" routerLinkActive="active">
      <i class="fa fa-arrow-circle-left" aria-hidden="true"></i>&nbsp;&nbsp; <span>{{'back' | translate}}</span>
    </button>
    <div>
      <h2>
        <h2 class="titolo-card" style="color: var(--cui-primary);">{{'appointment.home.title' | translate}}</h2>
      </h2>
    </div>
    <div class="form-group search-form">
      <button type="button" class="kcs-button-outlined mb-2 kcs-button kcs-component" (click)="OpenImpostaSlot()">
        <span class="kcs-button-label">Imposta slot</span>
      </button>
    </div>
  </div>

  <div>
    <full-calendar #calendar [options]="calendarOptions" style="color: var(--cui-dark) !important;"></full-calendar>
  </div>
</div>

<app-evento-appuntamento [date]="appuntamento" [tipo_utenza]="tipo_utenza" [cmp_id]="cmp_id" [visible]="visible" (visibleChange)="isVisible($event)"></app-evento-appuntamento>


<ng-template #modalCompanyCalendar>
  <div class="items-center">
    <div class="row">
      <label class="kcs-form-label" style="width: 100%"><b>Disponibilità Appuntamenti</b></label>
    </div>

    <div class="row">
      <div class="col-md-12">
        <label class="kcs-form-label" style="width: 100%">Giorni Disponibili</label>
        <p-multiSelect class="kcs-inputtext kcs-component" [options]="days" label="Seleziona giorni" label-placement="stacked" interface="popover" [(ngModel)]="calendario_obj.giorni_settimana"> <!-- (ngModelChange)="set_giorni_settimana($event)"-->
        </p-multiSelect>
      </div>
    </div>

    <div class="row">
      <div class="col-md-6">
        <div>
          <label class="kcs-form-label">Mattina Inizio</label>
          <p-datepicker [(ngModel)]="calendario_obj.mattina_inizio" (ngModelChange)="setTimeOutMorningStart($event)" [timeOnly]="true" [hourFormat]="'24'" placeholder="Ora Inizio" appendTo="body"></p-datepicker>
        </div>
      </div>
      <div class="col-md-6">
        <div>
          <label class="kcs-form-label">Mattina Fine</label>
          <p-datepicker [(ngModel)]="calendario_obj.mattina_fine" (ngModelChange)="setTimeOutMorningEnd($event)" [timeOnly]="true" [hourFormat]="'24'" placeholder="Ora Fine" appendTo="body"></p-datepicker>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-6">
        <div>
          <label class="kcs-form-label">Pomeriggio Inizio</label>
          <p-datepicker [(ngModel)]="calendario_obj.pomeriggio_inizio" (ngModelChange)="setTimeOutAfternoonStart($event)" [timeOnly]="true" [hourFormat]="'24'" placeholder="Ora Inizio" appendTo="body"></p-datepicker>
        </div>
      </div>
      <div class="col-md-6">
        <div>
          <label class="kcs-form-label">Pomeriggio Fine</label>
          <p-datepicker [(ngModel)]="calendario_obj.pomeriggio_fine" (ngModelChange)="setTimeOutAfternoonEnd($event)" [timeOnly]="true" [hourFormat]="'24'" placeholder="Ora Fine" appendTo="body"></p-datepicker>
        </div>
      </div>
    </div>

    <label class="kcs-form-label" style="width: 100%"><b>Giorni da Oscurare</b></label>

    <div class="row">
      <div class="col-md-5">
        <div>
          <label class="kcs-form-label" style="width: 100%">Da</label>
          <p-datepicker [(ngModel)]="date_da_obj" [showTime]="false" [dateFormat]="'dd/MM/yy'" placeholder="Data Inizio" [ngModelOptions]="{ standalone: true }" appendTo="body"></p-datepicker>
        </div>
      </div>

      <div class="col-md-5">
        <div>
          <label class="kcs-form-label" style="width: 100%">A</label>
          <p-datepicker [(ngModel)]="date_a_obj" [showTime]="false" [dateFormat]="'dd/MM/yy'" placeholder="Data Fine" [ngModelOptions]="{ standalone: true }" appendTo="body"></p-datepicker>
        </div>
      </div>

      <div class="col-md-2"><!--class="ion-text-end"-->
        <button type="submit" class="btn btn-primary" (click)="aggiungiIntervalloOscurato()">
          <i class="pi pi-plus" aria-hidden="true"></i>
        </button>
      </div>
    </div>

    @if (intervalliOscurati.length > 0) {
      <div>
        @for (intervallo of intervalliOscurati; track intervallo; let i = $index) {
          <div lines="full" class="flex">
            <label class="kcs-form-label" style="width: 100%">
              <div><strong>Dal:</strong> {{ intervallo.da | date:'dd/MM/yyyy' }}</div>
              <div><strong>Al:</strong> {{ intervallo.a | date:'dd/MM/yyyy' }}</div>
            </label>
            <button type="submit" class="btn btn-primary" (click)="rimuoviIntervallo(i)">
              <i class="pi pi-minus" aria-hidden="true"></i>
            </button>
          </div>
        }
      </div>
    }
  </div>
</ng-template>

<!--<ion-card>
<ion-card-header>
  <ion-card-title>
    <h5><b>Gestione Calendario</b></h5>
  </ion-card-title>
</ion-card-header>

<ion-card-content>
  <!-- Sezione 1: Disponibilità Appuntamenti
  <ion-label class="ion-padding-top" color="primary"><b>Disponibilità Appuntamenti</b></ion-label>

  <!-- Giorni disponibili
  <ion-item>
    <ion-label>Giorni Disponibili</ion-label>
    <ion-select placeholder="Seleziona giorni" multiple="true" [ngModel]="calendario_obj?.giorni_settimana" (ionChange)="set_giorni_settimana($event)" name="giorniFissi">
      <ion-select-option value="1">Lunedì</ion-select-option>
      <ion-select-option value="2">Martedì</ion-select-option>
      <ion-select-option value="3">Mercoledì</ion-select-option>
      <ion-select-option value="4">Giovedì</ion-select-option>
      <ion-select-option value="5">Venerdì</ion-select-option>
      <ion-select-option value="6">Sabato</ion-select-option>
      <ion-select-option value="0">Domenica</ion-select-option>
    </ion-select>
  </ion-item>

  <!-- Orari
  <ion-row>
    <ion-col size="6">
      <ion-item>
        <ion-label>Mattina Inizio</ion-label>
        <app-data-component [data_in]="calendario_obj?.mattina_inizio" (data_out)="setTimeOutMorningStart($event)" [type]="'time'"></app-data-component>
      </ion-item>
    </ion-col>
    <ion-col size="6">
      <ion-item>
        <ion-label>Mattina Fine</ion-label>
        <app-data-component [data_in]="calendario_obj?.mattina_fine" (data_out)="setTimeOutMorningEnd($event)" [type]="'time'"></app-data-component>
      </ion-item>
    </ion-col>
  </ion-row>

  <ion-row>
    <ion-col size="6">
      <ion-item>
        <ion-label>Pomeriggio Inizio</ion-label>
        <app-data-component [data_in]="calendario_obj?.pomeriggio_inizio" (data_out)="setTimeOutAfternoonStart($event)" [type]="'time'"></app-data-component>
      </ion-item>
    </ion-col>
    <ion-col size="6">
      <ion-item>
        <ion-label>Pomeriggio Fine</ion-label>
        <app-data-component [data_in]="calendario_obj?.pomeriggio_fine" (data_out)="setTimeOutAfternoonEnd($event)" [type]="'time'"></app-data-component>
      </ion-item>
    </ion-col>
  </ion-row>

  <ion-divider class="ion-margin-vertical"></ion-divider>

  <!-- Sezione 2: Giorni da Oscurare
  <ion-label class="ion-padding-top" color="danger"><b>Giorni da Oscurare</b></ion-label>

  <ion-row class="ion-align-items-end">
    <ion-col size="5">
      <ion-item lines="none">
        <ion-label position="stacked">Da</ion-label>
        <app-calendar-component (data_out)="setDataOscurareStart($event)" [data_in]="date_da" [type]="'date'"> </app-calendar-component>
      </ion-item>
    </ion-col>

    <ion-col size="5">
      <ion-item lines="none">
        <ion-label position="stacked">A</ion-label>
        <app-calendar-component (data_out)="setDataOscurareEnd($event)" [data_in]="date_a" [type]="'date'"> </app-calendar-component>
      </ion-item>
    </ion-col>

    <ion-col size="2" class="ion-text-end">
      <ion-button color="success" (click)="aggiungiIntervalloOscurato()"><ion-icon aria-hidden="true" name="add-outline"></ion-icon></ion-button>
    </ion-col>
  </ion-row>

  <ion-list *ngIf="intervalliOscurati.length > 0">
    <ion-item *ngFor="let intervallo of intervalliOscurati; let i = index" lines="full">
      <ion-label>
        <div><strong>Dal:</strong> {{ intervallo.da | date:'dd/MM/yyyy' }}</div>
        <div><strong>Al:</strong> {{ intervallo.a | date:'dd/MM/yyyy' }}</div>
      </ion-label>
      <ion-button slot="end" color="danger" fill="clear" size="small" (click)="rimuoviIntervallo(i)">
        <ion-icon name="trash-outline" slot="icon-only"></ion-icon>
      </ion-button>
    </ion-item>
  </ion-list>
</ion-card-content>
</ion-card>-->